import { fg } from '@atlassian/jira-feature-gating';
import { FormStatus } from '@atlassian/proforma-common-core/form-system-models';
import type { IssueIndexForm } from '@atlassian/proforma-common-core/jira-common-models';
import { FormRestrictionStatus } from '@atlassian/proforma-form-security';
import type { FormIndexItem } from '@atlassian/proforma-form-system';

export const convertToFormIndexItems = (formIndexList: IssueIndexForm[]): FormIndexItem[] =>
	formIndexList.map<FormIndexItem>((formIndex: IssueIndexForm) => {
		let status = FormStatus.Open;
		if (formIndex.lock) {
			status = FormStatus.Locked;
		} else if (formIndex.submitted) {
			status = FormStatus.Submitted;
		}
		return {
			id: formIndex.id,
			internal: formIndex.internal,
			status,
			name: formIndex.name,
			projectFormId: formIndex.projectFormId,
			...(fg('granular_permissions_on_forms_m1') && {
				restrictionStatus: formIndex.restrictionStatus ?? FormRestrictionStatus.OPEN,
			}),
			hasAccess: formIndex.hasAccess,
		};
	});
